import React, { useState } from 'react';
import SubscriberManager from './email/SubscriberManager';
import TemplateManager from './email/TemplateManager';
import CampaignManager from './email/CampaignManager';
import AutomationManager from './email/AutomationManager';

type EmailTab = 'subscribers' | 'templates' | 'campaigns' | 'automations';

const AdminEmail: React.FC = () => {
  const [activeTab, setActiveTab] = useState<EmailTab>('subscribers');

  const tabs: { id: EmailTab; label: string; enabled: boolean }[] = [
    { id: 'subscribers', label: 'Subscribers', enabled: true },
    { id: 'templates', label: 'Templates', enabled: true },
    { id: 'campaigns', label: 'Campaigns', enabled: true },
    { id: 'automations', label: 'Automations', enabled: true },
  ];

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <h1 className="font-heading text-4xl font-bold uppercase tracking-tighter">Email Marketing</h1>
      </div>

      {/* Tabs */}
      <div className="flex gap-8 border-b border-gray-200 overflow-x-auto">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => tab.enabled && setActiveTab(tab.id)}
            disabled={!tab.enabled}
            className={`pb-4 text-sm font-heading font-bold uppercase tracking-widest transition-colors whitespace-nowrap ${
              activeTab === tab.id
                ? 'border-b-2 border-black text-black'
                : tab.enabled
                ? 'text-gray-400 hover:text-black'
                : 'text-gray-300 cursor-not-allowed'
            }`}
          >
            {tab.label}
            {!tab.enabled && <span className="ml-1 text-xs">(Coming Soon)</span>}
          </button>
        ))}
      </div>

      {/* Content Area */}
      <div className="min-h-[500px]">
        {activeTab === 'subscribers' && <SubscriberManager />}
        {activeTab === 'templates' && <TemplateManager />}
        {activeTab === 'campaigns' && <CampaignManager />}
        {activeTab === 'automations' && <AutomationManager />}
      </div>
    </div>
  );
};

export default AdminEmail;
